<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12QkcWL/tc-custom/9781416979487.jpg?1730537180730" alt="This image is the cover for the book Perfect Cover, Nancy Drew Girl Detective"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perfect Cover, Nancy Drew Girl Detective
      </h1>
      <p class="bookDescription body article font2">
        <p>My friends and I are headed to the Big Apple! <br/><br/> George, Bess, and I continue our investigation of the Miss Pretty Face Beauty Pageant in New York City, where the next round of competition is being held. When I get there, Pretty Face Cosmetics seems creepier than ever! <br/><br/> Suspicious security men, animal rights protesters, and a mysterious scientist make this the craziest case I've ever investigated. And when someone suddenly goes missing, I realize it just might be the most dangerous!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolyn Keene
      </h2>
      
      <p class="authorDescription body article">Carolyn Keene is the author of the ever-popular Nancy Drew books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd5cec16